var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3.90956,
    fill: "#E30086"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_12565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9818 18.1664L14.9796 8.5L5.86719 23.9374L23.5002 20.1392L13.9818 18.1664ZM13.9081 18.2106C13.9265 18.1966 13.9442 18.1804 13.9627 18.1642H13.9767C13.9575 18.1826 13.9332 18.1944 13.9111 18.2106H13.9081Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9787 18.1663C13.9566 18.1825 13.9323 18.1943 13.9102 18.2105C13.9286 18.1965 13.9463 18.1803 13.9647 18.1641L13.9787 18.1663Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4994 20.1415L13.9832 18.1827V18.1709H13.9766L14.9787 8.50229C16.7274 7.89013 18.5836 7.90265 20.1237 8.63047C20.1451 8.64373 20.1694 8.65404 20.1974 8.66804C21.4621 9.26434 22.5578 10.167 23.385 11.2941C24.2122 12.4211 24.7447 13.7369 24.9341 15.1219C24.9378 15.1363 24.9395 15.1512 24.9393 15.1661C25.181 16.8575 24.6231 18.6453 23.4994 20.1415Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_12565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1289,
    height: 15.8794,
    fill: "white",
    transform: "translate(5.86328 8.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70f5e1c5e3247eb68d9d04d692623be4.svg";
export { ForwardRef as ReactComponent };